export function buildBankOptions(
  banksMap,
  placeholder = "انتخاب بانک",
) {
  return [
    { text: placeholder, value: null },
    ...Object.entries(banksMap || {})
      .filter(([, name]) => typeof name === "string" && name.trim())
      .map(([code, name]) => ({
        text: name.trim(),
        value: code,
      }))
      .sort((a, b) => a.text.localeCompare(b.text, "fa")),
  ];
}
